/*
*
* File JS componente Footer
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './footer.scss';

//--------------------------------------------------------------------//


const footer = () => {

const isMobile = () => {
    return window.innerWidth <= 769; 
};

const addIndicatorIcons = () => {
    const menuItems = document.querySelectorAll('.menu-footer-mobile .menu-item-has-children');
        menuItems.forEach(item => {
            const indicator = document.createElement('span');
            indicator.classList.add('submenu-indicator');

            const svgIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svgIcon.setAttribute('width', '20');
            svgIcon.setAttribute('height', '20');
            svgIcon.setAttribute('viewBox', '0 0 20 20');
            svgIcon.setAttribute('fill', 'none');
            svgIcon.innerHTML = `
                <path d="M14.1666 7.64174C14.0104 7.48653 13.7992 7.39941 13.5791 7.39941C13.3589 7.39941 13.1477 7.48653 12.9916 7.64174L9.99992 10.5917L7.04992 7.64174C6.89378 7.48653 6.68257 7.39941 6.46242 7.39941C6.24226 7.39941 6.03105 7.48653 5.87492 7.64174C5.79681 7.71921 5.73481 7.81138 5.69251 7.91293C5.6502 8.01448 5.62842 8.1234 5.62842 8.23341C5.62842 8.34342 5.6502 8.45234 5.69251 8.55389C5.73481 8.65544 5.79681 8.74761 5.87492 8.82507L9.40825 12.3584C9.48572 12.4365 9.57789 12.4985 9.67944 12.5408C9.78098 12.5831 9.88991 12.6049 9.99992 12.6049C10.1099 12.6049 10.2188 12.5831 10.3204 12.5408C10.4219 12.4985 10.5141 12.4365 10.5916 12.3584L14.1666 8.82507C14.2447 8.74761 14.3067 8.65544 14.349 8.55389C14.3913 8.45234 14.4131 8.34342 14.4131 8.23341C14.4131 8.1234 14.3913 8.01448 14.349 7.91293C14.3067 7.81138 14.2447 7.71921 14.1666 7.64174Z" fill="white"/>
            `;
            indicator.appendChild(svgIcon); 
            item.querySelector('.sub-menu').parentNode.insertBefore(indicator, item.querySelector('.sub-menu'));
        });
    };

const toggleSubmenus = () => {

    const indicators = document.querySelectorAll('.menu-footer-mobile .menu-item-has-children .submenu-indicator');
    indicators.forEach(indicator => {
        indicator.addEventListener('click', function(event) {
            event.preventDefault();
            const submenu = this.parentElement.querySelector('.sub-menu');
            if (submenu) {
                submenu.classList.toggle('open');
            }
        });
    });
};





// EXPORT COMPONENTE
//--------------------------------------------------------------------//

    if (isMobile()) {
        addIndicatorIcons();
        toggleSubmenus();
    }
    console.log('is mobile');
}

export default footer;

//--------------------------------------------------------------------//